import {useLocale} from "i18n";
import Seo from "../seo/Seo";
import {P2PContent} from "../home/landing/P2PContent";
import {p2pCopy} from "../home/landing/copy/p2p";

/**
 * Public, pre-rendered **Peer-to-peer transfer mode** page (`/p2p`, issue ui#133).
 *
 * Thin wrapper (mirrors {@link ./PricingRoute.tsx}): mounts `<Seo>` + the page body. SEO strings and
 * body copy live in {@link ../home/landing/copy/p2p.ts}, so a content agent edits only that module and
 * {@link ../home/landing/P2PContent.tsx}, never this wrapper. The canonical URL is derived from `path`
 * by `<Seo>` per active locale, so the `/ro` mirror needs no separate wiring.
 */
export function Component() {
	const {locale} = useLocale();
	const {seo} = p2pCopy[locale];
	return (
		<>
			<Seo title={seo.title} description={seo.description} path="/p2p"/>
			<P2PContent/>
		</>
	);
}
